import Container from '@mui/material/Container';
import { useErrorContext } from '@qpr/client-library';
import { Property } from '@qpr/components/Properties/views/properties-view-model';
import React, { useEffect, useState } from 'react';
import { useFilter } from '../../Filter/components/FilterContext';
import useHierarchyFilter from '../../Filter/components/useHierarchyFilter';
import useUrlFilters from '../../Filter/components/useUrlFilters';
import ExpandContext from '../components/ExpandContext';
import Map from '../components/Map';
import initialState, { MapViewState } from '../map-state';

interface MapViewProps {
  viewModel: { getData: () => Promise<MapViewState> };
  attributeInfo: Property[];
}

const MapView = ({ viewModel, attributeInfo }: MapViewProps) => {
  const [data, setData] = useState(initialState);
  const { setError } = useErrorContext();

  useUrlFilters();
  const { getActiveFilters, getSearchFilter } = useFilter();

  useEffect(() => {
    const initData = async () => {
      setError(null);
      const gotData = await viewModel.getData();
      if (gotData.error?.message) {
        setError(gotData.error);
        return;
      }
      setData(gotData);
    };
    initData();
  }, [viewModel]);

  const filteredHierarchy = useHierarchyFilter(data.hierarchy, getActiveFilters());
  const searchFilter = getSearchFilter();

  const searchFilteredHierarchy = useHierarchyFilter(
    filteredHierarchy,
    searchFilter ? [searchFilter] : []
  );

  return (
    <Container
      disableGutters
      component="main"
      maxWidth={false}
      id={data.hierarchy.id !== '' ? 'mapContainer' : 'loading'}
      data-testid="map-main"
    >
      <ExpandContext>
        <Map hierarchy={searchFilteredHierarchy} attributeInfo={attributeInfo} />
      </ExpandContext>
    </Container>
  );
};

export default MapView;
